import React, { useEffect, useState } from 'react';
import { DatePicker, message, Form, Input, Select, Skeleton } from "antd";
import { Button } from "evergreen-ui";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import FireFetch from "../../Firebase/FireFetch";
import { getStorage, uploadBytes, ref as storageRef } from "firebase/storage";
import { getDatabase, ref, update } from "firebase/database";
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


const { TextArea } = Input;
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");
const EditTask = (props) => {
    const { canAccessModule } = useAuth();
    const canUpdateTask = canAccessModule("TASKS", "update");
    const [showLoading, setShowLoading] = useState(false);
    const [taskFile, setTaskFile] = useState(null);
    const [taskImage, setTaskImage] = useState(null);
    const [task, setTask] = useState(props.task);
    const [userArray, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
    const [dueDate, setDueDate] = useState(null);

    useEffect(() => {
        setTask(props.task);
    }, [props.task]);

    const handleFileUpload = (e) => {
        setTaskFile(e.target.files[0]);
    }

    const handleImage = (e) => {
        setTaskImage(e.target.files[0]);
    }

    function onChange(value, dateString) {
        setDueDate(dateString);
    }

    const editTask = (values) => {
        if (!canUpdateTask) {
            message.error("You do not have permission to update tasks.");
            return;
        }

        var createdDate = moment().format("YYYY-MM-DD");

        var object = {
            "task": values.task,
            "taskLink": values.taskLink,
            "repeat": values.repeat ? values.repeat : "",
            "repeatEvery": values.repeatEvery,
            "description": values.description,
            "createdDate": createdDate,
            "dueDate": dueDate,
            "createdBy": values.createdBy,
            "assignedTo": values.assigned,
            "taskImageKeywords": values.keywords,
            "taskStatus": values.status,
        }
        Object.entries(object).forEach(([key, value]) => {
            if (value === undefined) {
                object[key] = "";
            }
        });
        update(ref(db, "talmidsdb/Tasks/" + task.taskID), object)
            .then(() => {
                FireFetch.addLog("Tasks", task.taskID, "Edit");
                message.success("Task updated successfully");
                props.modal(false);

                if (taskFile !== null || taskImage !== null) {
                    uploadBytes(storageRef(storage, "talmidsdb/Tasks/" + task.taskID + "/taskImage"), taskImage)
                        .then(function (snapshot) {
                            console.log('Uploaded a blob or file!');

                        }).then(() => {
                            uploadBytes(storageRef(storage, "talmidsdb/Tasks/" + task.taskID + "/taskAttachment"), taskFile)
                                .then(function (snapshot) {
                                    console.log('Uploaded a blob or file!');
                                }).catch((error) => {
                                    console.log(error)
                                });

                        })
                }

            })
            .catch((error) => {
                message.error("unable to update Task due to an error : " + error);

            })




    }

    if (usersLoading) {
        return <Skeleton active paragraph={{ rows: 10 }} />;
    }

    return (
        <>
            <Form layout={"vertical"}
                onFinish={editTask}
                initialValues={{
                    task: task?.task,
                    status: task?.taskStatus,
                    description: task?.description,
                    dueDate: moment(task?.dueDate, "YYYY-MM-DD"),
                    taskLink: task?.taskLink,
                    assigned: task?.assigned,
                    keywords: task?.taskImageKeywords,
                    repeat: task?.repeat,
                    repeatEvery: task?.repeatEvery,
                    createdBy: task?.createdBy
                }}
            >
                <Form.Item label="task" name="task">
                    <Input placeholder="task" id="task" />
                </Form.Item>
                <Form.Item label="Task Status" name="status">
                    <Select placeholder="Select task status"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Pending", "Done"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Description" name="description">
                    <TextArea placeholder="description" id={"desc"} />
                </Form.Item>
                <Form.Item label="Task Image">
                    <Input type="file"
                        style={{ width: "100%" }}
                        accept="image/*"
                        onChange={handleImage}
                        placeholder="task image" id="task-image" />
                    <img src={task && task.urls[1]} className="img-fluid p-2" alt="image" />
                </Form.Item>
                <Form.Item label="Task Link" name="taskLink">
                    <Input type="text" placeholder="task link" id="link" />
                </Form.Item>
                <Form.Item label="Task Image Keywords" name="keywords">
                    <Input type="text" placeholder="task image keywords" id="keywords" />
                </Form.Item>
                <Form.Item label="Due Date" name="dueDate">
                    <DatePicker onChange={onChange} style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item label="Created By" name="createdBy">
                    <Select placeholder="Select created by user"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
                            <Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Assigned" name="assigned">
                    <Select placeholder="Select user assigned"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
                            <Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Repeat" name="repeat">
                    <Select placeholder="Select task repeat"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Yes", "No"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Repeat Every"
                    name="repeatEvery">
                    <Select placeholder="Select task repeat frequency"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {["Daily", "Weekly", "Monthly", "Yearly"].map((item, index) => (
                            <Select.Option key={index} value={item}>{item}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="File">
                    <Input type="file"
                        style={{ width: "100%" }}
                        accept="image/*"
                        onChange={handleFileUpload}
                        placeholder="task file" id="task-file" />
                    <img src={task && task.urls[0]} className="img-fluid p-2" alt="image" />
                </Form.Item>

                <Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canUpdateTask}>
                    Edit
                </Button>
            </Form>

        </>
    )
}

export default EditTask;
